<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Title Page">
<p class="title"><span class="right_1" epub:type="pagebreak" id="page_iii" title="iii">MOTOR CITY<br/>MOVIE CULTURE,<br/>1916–1925</span></p>
<p class="author1">Richard Abel</p>
<p class="logo"><span class="small">INDIANA UNIVERSITY PRESS</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 00a_fm0b.vue?6d5399b6